import React, {useEffect, useState} from 'react';
import {
  HStack,
  VStack,
  Divider,
  AddIcon,
  Heading,
  Text,
  Pressable,
  Box,
} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../../context/salesman';
import useToast from '../../../../../../hooks';
import {IProduct} from '../../../../../../context/user/Types';
import {SpinnerModal} from '../../../../../../components/modals';
import {StackParamList} from '../../../../../../navigators';
import {SearchInput} from '../../../../../../components/inputs';
import InternalTemplate from '../../../../../../components/templates/internal';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanProductSearch'
>;

const SalesmanProductSearch = ({navigation, route}: ScreenProps) => {
  const {
    salesmanProductList: list,
    fetchSalesmanProducts,
    setSalesmanProductToAdd,
    salesmanProductToAdd,
    customerOrder,
  } = useSalesmanContext();
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {showServerError} = useToast();

  const [filtered, setFiltered] = useState([] as IProduct[]);

  const getSalesmanProductList = async () => {
    setIsLoading(true);
    if (
      customerOrder &&
      customerOrder?.priceListId &&
      customerOrder?.paymentOptionId
    ) {
      const result = await fetchSalesmanProducts(
        customerOrder?.priceListId,
        customerOrder?.paymentOptionId,
      );
      if (!result) {
        showServerError();
      }
    }
    setIsLoading(false);
  };

  const handleGoBack = () => {
    if (salesmanProductToAdd) {
      navigation.pop(1);
      return;
    }
    if (route.params?.goBackDashboard) {
      navigation.pop(4);
      return;
    }

    navigation.pop(2);
  };

  useEffect(() => {
    if (list == null) {
      getSalesmanProductList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  useEffect(() => {
    const search = searchText.trim().toLowerCase();
    if (list) {
      if (search !== '') {
        const listFiltered = list.filter(
          el =>
            el.title.toLowerCase().includes(search) ||
            el.summary.toLowerCase().includes(search),
        );
        setFiltered(listFiltered);
      } else {
        setFiltered(list);
      }
    }
  }, [searchText, list]);

  const handleOnChange = (value: string) => {
    setSearchText(value);
  };

  const getStripedColor = (index: number) => {
    const isEven = index % 2 === 0;
    if (isEven) {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  const handleOnPress = (product: IProduct) => {
    setSalesmanProductToAdd(product);
    navigation.pop(1);
  };

  return (
    <InternalTemplate
      title={'salesman-order-add-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack>
        <SpinnerModal show={isLoading} />
        <Box paddingX={5}>
          <SearchInput
            onChange={handleOnChange}
            readonly={false}
            label="salesman-order-search-product-input"
          />
          <Divider width={'100%'} bgColor={'#D9EDFF'} />
        </Box>
        {filtered.map((item: IProduct, index: number) => (
          <Pressable
            key={`product_search_item_${index.toString()}`}
            onPress={() => handleOnPress(item)}>
            <HStack
              justifyContent={'space-between'}
              marginY={1}
              paddingX={5}
              paddingY={2}
              backgroundColor={getStripedColor(index)}>
              <VStack>
                <Heading fontSize={16} color="#4C4C4C">
                  {item.title}
                </Heading>
                <Text fontSize={12} color="#99A2B4">
                  {item.summary}
                </Text>
              </VStack>

              <AddIcon size={6} color="#0088FF" />
            </HStack>
          </Pressable>
        ))}
      </VStack>
    </InternalTemplate>
  );
};
export default SalesmanProductSearch;
